import { RHFTextField, Section, RHFDateTextField } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import React from "react";
import { AURA_QUESTION } from "../../config/const/enums";

function AuraQuestionDate({ mappedContent }) {
  return (
    <Section md={7}>
      {mappedContent.context && (
        <Section mb={3}>
          <Typography
            mb={4}
            sx={{
              width: "fit-content !important",
            }}
            variant="label-large-bold"
          >
            {mappedContent.context}
          </Typography>
        </Section>
      )}
      {mappedContent.statement && (
        <Typography
          sx={{
            marginBottom: 5 / 2,
            display: "flex",
          }}
          variant="label-large-bold"
        >
          {mappedContent.statement}
        </Typography>
      )}
      <Typography
        sx={{
          marginBottom: 4,
        }}
        variant="label-large-bold"
        dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
      ></Typography>
      <Section sm={5} mt={3}>
        <RHFDateTextField
          name={AURA_QUESTION.AURA_QUESTION_NAME}
          defaultValue={""}
          variant="standard"
          label="Month/Year"
          showErrorCard={true}
          inputFormat="MM/yyyy"
          views={["year", "month"]}
        />
      </Section>
    </Section>
  );
}

export default AuraQuestionDate;
